import axios from 'axios';
import mainConfig from '../config';
let {baseUrl} = mainConfig;
const instance = axios.create({
    baseURL: baseUrl,
    timeout: 100000
})

//添加拦截
instance.interceptors.request.use(config => {
    if(!config.noAddSession) {
        let data = localStorage.getItem('commercialUserData');
        if(data && JSON.parse(data).Session) {
            let prop = 'params';
            if(!config[prop]) {config[prop] = {}}
            config[prop]['session'] = JSON.parse(data).Session;
            config[prop]['sessioin'] = JSON.parse(data).Session;
        }
    }
    return config
},error => {
    return error;
})
instance.interceptors.response.use(res => {
    if(res.data && [20103, 20101, 20202].indexOf(res.data.Status) > -1) {
        localStorage.removeItem('commercialUserData');
        window.location.href = document.location.origin;
    }
    return res.data
},error => {
    if(error.response && error.response.status === 500) {
        localStorage.removeItem('commercialUserData');
        window.location.href = document.location.origin;
    }
    return error;
})
export default instance;
